import { selectVariantSlicerGridData, rebuildPVDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import { updateVariantSlicerVariantChart } from '@process-advisor/process-miner/api/methods/slicers/updateVariantSlicerVariantChart';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { updateGauges } from '@process-advisor/process-miner/api/methods/slicers/updateGauges';

export type Row = {
    variant: string;
    sequence: string;
    tasks: number;
    avg_duration: number;
    std_deviation: number;
    loop: boolean;
    compliant: boolean;
};

export type GridRow = Row & { id: number }

export type SetVariantSlicerSelectedDataProps = ApiMethodBase & {
    selection: Row[],
    mode?: any,
    source?: string
};

export const setVariantSlicerSelectedData = ({
    selection,
    source,
    mode,
    eventEmitter ,
}: SetVariantSlicerSelectedDataProps) => {
    selectVariantSlicerGridData(selection, source);
    updateVariantSlicerVariantChart({ eventEmitter });
    rebuildPVDiagram('selectVariantSlicerGridData');
    updateGauges({ eventEmitter });

};
